import React from "react";
import { Route } from "react-router-dom";
import TeacherAdminPage from "./../../Components/Dashboard/Admin-panel/TeacherAdminPage";
import CourseAdminPending from "./../../Components/Dashboard/Admin-panel/CourseAdminPending";
import CourseAdminApproval from "./../../Components/Dashboard/Admin-panel/CourseAdminApproval";
import TeacherInformation from "./../../Components/Dashboard/Admin-panel/TeacherInformation";
import StudentCourseRequestsPage from "./../../Components/Dashboard/Admin-panel/StudentCourseRequestsPage";
import StudentAdminPage from "./../../Components/Dashboard/Admin-panel/StudentAdminPage";
import TeacherCourseManager from "./../../Components/Dashboard/Admin-panel/TeacherCourseManager";
import StudentCourseManager from "./../../Components/Dashboard/Admin-panel/StudentCourseManager";
import ManageAllUsers from "./../../Components/Dashboard/Admin-panel/ManageAllUsers";
import AdminBankTransferPaymentsPage from "./../../Components/Dashboard/Admin-panel/AdminBankTransferPaymentsPage";
import AdminOnlinePaymentsPage from "./../../Components/Dashboard/Admin-panel/AdminOnlinePaymentsPage";
import AdminPaymentTrackingPage from "./../../Components/Dashboard/Admin-panel/AdminPaymentTrackingPage";
import EventAdminPage from "./../../Components/Dashboard/Admin-panel/EventAdminPage";
import AdminSettingsPage from "./../../Components/Dashboard/Admin-panel/AdminSettingsPage";
import AdminAusbildungPage from "./../../Components/Dashboard/Admin-panel/AdminAusbildungPage";
import AdminSiteFeedbackPage from "./../../Components/Dashboard/Admin-panel/AdminSiteFeedbackPage";
import AdminCourseInterestPage from "./../../Components/Dashboard/Admin-panel/AdminCourseInterestPage";
import AdminConversationCoursePage from "./../../Components/Dashboard/Admin-panel/AdminConversationCoursePage";
import TeacherCredentialExportPage from "./../../Components/Dashboard/Admin-panel/TeacherCredentialExportPage";
import AdminTeacherFeedbackPage from "./../../Components/Dashboard/Admin-panel/AdminTeacherFeedbackPage";
import AdminUnlinkedAusbildungApplicationsPage from "./AdminUnlinkedAusbildungApplicationsPage";
import ProtectedRoute from "../../Components/ProtectedRoute";

const ForceEnglish = ({ children }) => {
  return children;
};

/**
 * role: string (optional, for backward compatibility)
 * roleNames: array of roles (optional, preferred)
 */
const AdminRoutes = (role, roleNames) => {
  const effectiveRoles = roleNames?.length
    ? roleNames.map((r) => r.toUpperCase())
    : role
    ? [role.toUpperCase()]
    : [];

  return [
    <Route key="teacher-feedbacks" path="/dashboard/teacher-feedbacks" element={<ForceEnglish><ProtectedRoute element={<AdminTeacherFeedbackPage />} allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles} /></ForceEnglish>} />,
    <Route key="conversation-course-customization" path="/dashboard/customize-conversation-courses" element={<ForceEnglish><ProtectedRoute element={<AdminConversationCoursePage />} allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles} /></ForceEnglish>} />,
    <Route key="teacher-credential-export" path="/dashboard/teacher-credentials" element={<ForceEnglish><ProtectedRoute element={<TeacherCredentialExportPage />} allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles} /></ForceEnglish>} />,
    <Route key="course-interests" path="/dashboard/course-interests" element={<ForceEnglish><ProtectedRoute element={<AdminCourseInterestPage />} allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles} /></ForceEnglish>} />,
    <Route
      key="site-feedback"
      path="/dashboard/site-feedback"
      element={<ForceEnglish><ProtectedRoute element={<AdminSiteFeedbackPage />} allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles} /></ForceEnglish>}
    />,
    <Route
      key="admin-ausbildung"
      path="/dashboard/ausbildung-management"
      element={<ForceEnglish><ProtectedRoute element={<AdminAusbildungPage />} allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles} /></ForceEnglish>}
    />,
    <Route key="admin-unlinked-ausbildung" path="/dashboard/ausbildung/unlinked-applications" element={<ForceEnglish><ProtectedRoute element={<AdminUnlinkedAusbildungApplicationsPage />} allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles} /></ForceEnglish>} />,
    <Route
      key="payment-tracking"
      path="/dashboard/payments"
      element={<ForceEnglish><ProtectedRoute element={<AdminPaymentTrackingPage />} allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]} userRoles={effectiveRoles} /></ForceEnglish>}
    />,
    <Route
      key="students"
      path="/dashboard/students"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<StudentAdminPage />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="teachers"
      path="/dashboard/teachers"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<TeacherAdminPage />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="pending"
      path="/dashboard/courses/pending"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<CourseAdminPending />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="approvals"
      path="/dashboard/courses/approvals"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<CourseAdminApproval />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="teacher-details"
      path="/dashboard/teacher/:teacherId/details"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<TeacherInformation />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="course-requests"
      path="/dashboard/students-courses-requested"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<StudentCourseRequestsPage />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="bank-transfer-payments"
      path="/dashboard/payments/bank-transfer"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<AdminBankTransferPaymentsPage />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    <Route
      key="online-payments"
      path="/dashboard/payments/online"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<AdminOnlinePaymentsPage />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,

    <Route
      key="events"
      path="/dashboard/events"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<EventAdminPage />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,

    <Route
      key="settings"
      path="/settings"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<AdminSettingsPage />}
            allowedRoles={["ADMIN", "ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,

    <Route
      key="teacher-course-manager"
      path="/dashboard/teacher-course-manager"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<TeacherCourseManager />}
            allowedRoles={["ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    
    <Route
      key="student-course-manager"
      path="/dashboard/student-course-manager"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<StudentCourseManager />}
            allowedRoles={["ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,

    <Route
      key="manage-all-users"
      path="/dashboard/manage-all-users"
      element={
        <ForceEnglish>
          <ProtectedRoute
            element={<ManageAllUsers />}
            allowedRoles={["ADMIN_DEVELOPER"]}
            userRoles={effectiveRoles}
          />
        </ForceEnglish>
      }
    />,
    
  ];
};

export default AdminRoutes;
